import Vue from "vue";
import VueRouter, {RouteConfig} from "vue-router";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    {
        path: "/",
        name: "home",
    }, {
        path: "/osobne-udaje",
        name: "personalInfo",
        component: () => import("../views/PersonalInformation.vue"),
    // }, {
    //     path: "/activation/:activationToken?",
    //     name: "activation",
    //     component: () => import("../views/Activation.vue"),
    }, {
        path: "/login/:loginToken?",
        name: "login",
        component: () => import("../views/Login.vue"),
    }, {
        path: "/investicny-dotaznik",
        name: "questionnaire",
        component: () => import("../views/InvestmentQuestionnaire.vue"),
    }, {
        path: "/zhrnutie",
        name: "onboardingSummary",
        component: () => import("../views/Summary.vue"),
    },  {
        path: "/vyber-strategie",
        name: "strategies",
        component: () => import("../views/Strategies.vue"),
    }, {
        path: "/zmluvna-dokumentacia",
        name: "documentation",
        component: () => import("../views/Documentation.vue"),
    }, {
        path: "/dokumenty",
        name: "documents",
        component: () => import("../views/Documents.vue"),
    }, {
        path: "/dokoncenie",
        name: "successScreen",
        component: () => import("../views/SuccessScreen.vue"),
    },
    {
        path: "/service-down",
        name: "serviceDown",
        component: () => import("../views/ServiceDown.vue"),
    }
];

const router = new VueRouter({
    // mode: "history",
    base: process.env.BASE_URL,
    routes
});

export default router;
